import {useId} from "react";
import {Box, Checkbox, FormControlLabel, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export default function CheckoutPermissionControl({group, selected, checked, disabled, onChange}) {
    const {t} = useTranslation();
    const descriptionId = useId();
    return <Box sx={{p: {xs: 1.5, sm: 2}, borderTop: "1px solid", borderColor: "divider", bgcolor: "action.hover"}}>
        <Typography variant="subtitle2">{t("CheckoutPartialPermissionTitle")}</Typography>
        <FormControlLabel sx={{alignItems: "flex-start", my: 0.5, "& .MuiCheckbox-root": {py: 0.5}}}
            label={t("CheckoutPartialPermissionOptIn")} control={<Checkbox checked={selected && checked}
                disabled={disabled || !selected} onChange={event => onChange(event.target.checked)}
                inputProps={{"aria-label": t("CheckoutPermissionFor", {name: group.name || t("Distributor")}),
                    "aria-describedby": descriptionId, "data-checkout-permission": group.id}}/>}/>
        <Box id={descriptionId}>
            <Typography variant="caption" display="block" color="text.secondary">{t("CheckoutPartialPermissionExplanation")}</Typography>
            <Typography variant="caption" display="block" color="text.secondary" sx={{mt: 0.5}}>{t("CheckoutPartialPermissionExclusions")}</Typography>
            {!selected && <Typography variant="caption" display="block" sx={{mt: 0.5}}>{t("CheckoutPermissionSelectProducts")}</Typography>}
        </Box>
    </Box>;
}
